import { Edit, Delete } from "@mui/icons-material";

import { TableActions } from "../../components/v3";

/**
 * Route paths for the office account module.
 * Single source of truth — reuse these instead of hard-coding `/office/overview` strings.
 */
export const OFFICE_ROUTES = {
  overview: "/office/overview",
} as const;

export const OfficeIncomeTableColumns = (handleActions, canEditIncome, canDeleteIncome) => {
  const headers = [
    {
      field: "sl",
      headerName: "Sl No",
      sortable: false,
    },
    { field: "date", headerName: "Date", flex: 0.5, sortable: true, sortingOrder: ["desc", "asc", null] },
    {
      field: "description",
      headerName: "Description",
      flex: 1.5,
      sortable: true,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      sortable: true,
    },
  ];

  if (canEditIncome || canDeleteIncome) {
    headers.push({
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        const actions = [];
        if (canEditIncome) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }
        if (canDeleteIncome) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }
        return <TableActions item={params} actions={actions} />;
      },
    });
  }

  return headers;
};

export const OfficePurchaseTableColumns = (handleActions, canEditPurchase, canDeletePurchase) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.2, sortable: false },
    { field: "date", headerName: "Date", flex: 0.5, sortable: true, sortingOrder: ["desc", "asc", null] },
    { field: "type", headerName: "Type", flex: 1, sortable: false },
    {
      field: "vendorName",
      headerName: "Vendor",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const value = params.value;
        const { type } = params.row;
        if (!value) return "-";
        const color = type === "Return" ? "black" : "red";
        return <span style={{ color, display: "flex", alignItems: "center", gap: 4 }}>₹ {Number(value).toFixed(2)}</span>;
      },
    },
  ];

  if (canEditPurchase || canDeletePurchase) {
    headers.push({
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        const actions = [];
        if (canEditPurchase) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }
        if (canDeletePurchase) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }
        return <TableActions item={params} actions={actions} />;
      },
    });
  }

  return headers;
};
